// Terms of Use for AeroGuard SMS pilot phase.
import LegalPageLayout from './LegalPageLayout';

const H = ({ children }) => (
  <h2 className="text-white text-xl font-semibold mt-8 mb-2">{children}</h2>
);
const P = ({ children }) => (
  <p className="text-slate-300 text-[15px]">{children}</p>
);

export default function TermsOfUsePage({ onBack, companyName = 'AeroGuard SMS' }) {
  return (
    <LegalPageLayout title="Terms of Use" effective="February 2026" onBack={onBack}>
      <P>
        These Terms of Use ("Terms") govern access to the {companyName} platform.
        By signing in you accept these Terms on behalf of yourself and your
        operator organisation.
      </P>

      <H>Pilot service</H>
      <P>
        The Platform is currently offered on a pilot basis. During the pilot
        we make no service-level commitment and reserve the right to make
        breaking changes with reasonable notice. Production terms with
        uptime and support SLAs will supersede these when the operator
        transitions to a paid subscription.
      </P>

      <H>Accounts and eligibility</H>
      <ul className="list-disc pl-6 space-y-1 text-slate-300 text-[15px]">
        <li>You must be at least 18 years old to hold an account.</li>
        <li>You are responsible for keeping your credentials confidential and for every action performed under your account.</li>
        <li>Sharing accounts between individuals is prohibited.</li>
        <li>You will change your temporary password on first login and follow the operator's password policy thereafter.</li>
      </ul>

      <H>Acceptable use</H>
      <P>
        You will not: (a) upload malware or content that infringes any
        third-party right; (b) attempt to circumvent authentication or the
        multi-business-unit scoping; (c) probe or load-test the Platform
        without written consent; (d) use the Platform to store data unrelated
        to aviation safety management. AI-assisted features (help,
        dictation, text polish, business-intelligence "ask the data") must
        not be used to generate content that violates applicable law.
      </P>

      <H>Data ownership</H>
      <P>
        Operators retain all rights to safety records they upload. We claim
        no ownership over Customer Data. During the pilot we may generate
        aggregated, de-identified statistics to improve the Platform.
      </P>

      <H>AI-generated content</H>
      <P>
        Outputs of AI-assisted features (Emergent LLM, GPT-family models,
        Whisper transcription) are provided on an "as-is" basis. Safety
        managers must review AI output before acting on it — the Platform
        does not replace human judgement in aviation safety decisions.
      </P>

      <H>Warranty disclaimer</H>
      <P>
        THE PLATFORM IS PROVIDED "AS IS" AND "AS AVAILABLE" DURING THE PILOT.
        TO THE MAXIMUM EXTENT PERMITTED BY LAW WE DISCLAIM ALL IMPLIED
        WARRANTIES, INCLUDING MERCHANTABILITY, FITNESS FOR A PARTICULAR
        PURPOSE AND NON-INFRINGEMENT.
      </P>

      <H>Limitation of liability</H>
      <P>
        To the maximum extent permitted by law, our aggregate liability
        arising from or relating to these Terms during the pilot period is
        limited to fees paid (which is nil during a free pilot). Nothing
        limits liability that cannot be excluded under applicable law.
      </P>

      <H>Termination</H>
      <P>
        Either party may terminate the pilot at any time with written
        notice. Upon termination you may request an export of your data
        within thirty (30) days, after which we will delete it.
      </P>

      <H>Governing law and disputes</H>
      <P>
        These Terms are governed by the laws of the Kingdom of Saudi Arabia,
        without regard to conflict-of-law rules. Disputes will be resolved by
        the competent courts in Riyadh, unless the pilot agreement provides
        otherwise.
      </P>

      <H>Changes</H>
      <P>
        We may update these Terms during the pilot; the "Effective" date
        above shows the current version. Continued use of the Platform after
        an update constitutes acceptance.
      </P>
    </LegalPageLayout>
  );
}
